import type { Board } from "../board";
import { DamageType } from "../damageType";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import { MeleeHitMovementEffect } from "../effects/meleeHitMovementEffect";
import { isProjectileHittable } from "../interfaces";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import type { Player } from "../player";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class Punch extends Weapon {
	static key = "Punch";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getAutoFireRange(): number {
		return 1;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.NONE;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.MOB_PHISICAL_ATTACK, this.owner.xy));
		const targetPos = this.owner.xy.add(directionDelta(direction));
		if (!board.isInBounds(targetPos)) return;

		const targets = board
			.getCell(targetPos)
			.getThings()
			.filter((t) => t.active)
			.filter((t) => isProjectileHittable(t) && t.isHittable());

		for (const target of targets) {
			if (!target.active) continue;
			if (target instanceof PhysicalThingWithHp) {
				target.applyDamage(DamageType.MELEE, STD_BASE_HP / 2, this.owner);
				board.addEffect(new MeleeHitMovementEffect(board.player!, this.owner.xy, targetPos));
			}
		}
	}

	static deserialize(data: any, owner: Player): Punch {
		const weapon = new Punch(owner);
		weapon.ammo = data.ammo;
		return weapon;
	}
}
